export interface Route {
  name: string
  description?: string
  icon?: string
  path: string
  label?: string
  roles?: Array<string>
  routes?: Array<Route>
  meta?: {
    title: string
    description: string
  }
}

export enum Role {
  IS_ADMIN = 'isAdmin'
}

export const routes: Array<Route> = [
  // integration
  {
    name: 'API連携サービス管理',
    label: 'API連携サービス管理',
    path: '/',
    routes: [
      {
        name: 'API連携サービス管理',
        label: 'API連携サービス管理',
        path: '/integration',
        description:
          '各種CRM/MAツールのAPI連携を設定することができます。連携後は、設定済みのツールのデータをダイレクトメール発送時の宛名リストとしてインポートしたり、ダイレクトメールの発送履歴を連携したサービスに記録することができます。',
        routes: [
          {
            name: 'Salesforce API連携',
            label: 'Salesforce API連携',
            path: '/salesforce',
            description:
              'API連携により、Salesforceの情報をラクスルのダイレクトメールサービスに連携することができます。',
            meta: {
              title: 'Salesforce',
              description: `SaleforceとのAPI連携を設定することができます。\nAPI連携後は、SalesforceのレポートをDM発送時の宛名リストとしてインポートし、DMの発送、QRコードの読み取り履歴をSalesforce側に記録することが可能です`
            }
          },
          {
            name: 'HubSpot API連携',
            label: 'HubSpot API連携',
            path: '/hubspot',
            meta: {
              title: 'HubSpot',
              description: `HubSpotとのAPI連携を設定することができます。\nAPI連携後は、HubSpotのセグメントをDM発送時の宛名リストとしてインポートし、DMの発送、QRコードの読み取り履歴をHubSpot側に記録することが可能です`
            }
          }
        ]
      }
    ]
  }
]

/*
 * Find the Route by path
 */
export const findRoute = (
  routes: Array<Route>,
  path: string | undefined
): Route | undefined => {
  if (path === undefined) {
    return undefined
  }

  for (const route of routes) {
    if (route.path === path) {
      return route
    }

    if (route.routes && route.routes.length > 0) {
      if (route.path !== '/' && path.includes(route.path)) {
        path = path.replace(route.path, '')
      }

      const found = findRoute(route.routes, path)

      if (found !== undefined) {
        return found
      }
    }
  }

  return undefined
}

/*
 * Find the Routes by fullPath
 */
export const findRoutes = (fullPath: string): Array<Route> => {
  const pathRoutes = []
  const paths = fullPath.split('/').map((path) => `/${path.replace('?', '')}`)

  // the first path is always the TOP route
  if (fullPath !== '/') {
    paths.shift()
  }

  let subRoutes = routes[0].routes || []
  while (paths.length > 0) {
    const path = paths.shift()
    const route = findRoute(subRoutes, path)
    if (route) {
      pathRoutes.push(route)
      subRoutes = route.routes || []
    } else {
      break
    }
  }

  return pathRoutes
}
